<template>
    <v-card>
        <v-card-title>お相手選択</v-card-title>
        <v-card-subtitle>{{ customer.family_name }} {{ customer.given_name }} ({{customer.family_name_kana}} {{customer.given_name_kana}})</v-card-subtitle>
        <v-container fluid>
            <v-row dense>
                <v-col>
                    <v-btn
                        :to="`/customer/${$route.params.id}`"
                    >カルテ
                    </v-btn>
                    <v-btn
                        :to="`/customer/history/${$route.params.id}`"
                    >経緯表
                    </v-btn>
                    <v-btn
                        v-if="customer.gender!=2"
                        :to="`/customer/matching/${$route.params.id}`"
                    >お相手選択
                    </v-btn>
                    <v-btn
                        v-else
                        :to="`/customer/matching_history/${$route.params.id}`"
                    >お相手履歴
                    </v-btn>
                    <v-btn
                        @click="openSheet(customer.sheet_id)"
                        v-if="customer.sheet_id"
                    >旧カルテを開く
                    </v-btn>
                    <v-btn
                        :to="`/customer/file-manager/${$route.params.id}`"
                    >画像管理
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid>
            <v-row>
                <v-col cols="6" sm="3" lg="2">
                    <v-text-field
                        v-model="conditionsName"
                        type="text"
                        label="名前">
                    </v-text-field>
                </v-col>

                <v-col cols="6" sm="3" lg="2">
                    <v-select
                        v-model="conditionsShopId"
                        :items="shops"
                        label="支店"
                    ></v-select>
                </v-col>

                <v-col cols="6" sm="3" lg="2">
                    <v-select
                        v-model="conditionsCounselorId"
                        :items="counselors"
                        label="担当CO"
                    ></v-select>
                </v-col>

                <v-col cols="6" sm="3" lg="2">
                    <v-select
                        v-model="conditionsAge"
                        :items="ageList"
                        label="年齢"
                    ></v-select>
                </v-col>
            </v-row>
        </v-container>
        <v-data-table
            :headers="headers"
            :items="histories"
            :server-items-length="histories.length"
            :loading="loading"
            hide-default-footer
            dense
            :search="search"
            :custom-filter="customFilter"
        >
            <template v-slot:[`item.counselor`]="{ item }">
                {{ showCounselorName(item.counselor_id) }}
            </template>
            <template v-slot:[`item.shop`]="{ item }">
                {{ showShopName(item.shop_id) }}
            </template>
            <template v-slot:[`item.age`]="{ item }">
                {{item.age}}歳
            </template>
            <template v-slot:[`item.kind`]="{ item }">
                {{showKind(item.kind)}}
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import utilDatetime from "@/utilities/datetime.js"
export default {
    title() {
        return `${this.customer.family_name} ${this.customer.given_name} (お相手選択)`;
    },
    name: 'customer_matching_history',
    mixins: [utilDatetime],
    data: () => ({
        customer: {
            family_name: "",
            given_name: "",
            family_name_kana: "",
            given_name_kana: "",
        },
        headers: [
            { text: "No.", value: "no", align: "start", sortable: false },
            { text: "名前", value: "name", align: "start", sortable: false },
            { text: "支店", value: "shop", align: "start", sortable: false },
            { text: "担当CO", value: "counselor", align: "start", sortable: false },
            { text: "年齢", value: "age", align: "start", sortable: false },
            { text: "種別", value: "kind", align: "start", sortable: false },
            { text: "日付", value: "date", align: "start", sortable: false },
        ],
        histories: [],
        loading: true,
        counselors: [],
        shops: [],
        ageList: [
            { value:  0, text: "全て" },
            { value: 20, text: "20代" },
            { value: 30, text: "30代" },
            { value: 40, text: "40代" },
            { value: 50, text: "50代" },
            { value: 60, text: "60代～" }
        ],
        conditionsName: '',
        conditionsShopId: 0,
        conditionsCounselorId: 0,
        conditionsAge: 0,
        search: "",
    }),
    watch: {
        conditionsName() { this.search = this.getFilter(); },
        conditionsShopId() { this.search = this.getFilter(); },
        conditionsCounselorId() { this.search = this.getFilter(); },
        conditionsAge() { this.search = this.getFilter(); },
    },
    async mounted() {
        await this.loadInit();
    },
    methods: {
        async loadInit() {
            const id = this.$route.params.id;
            const result = await this.$axios
                .get(`/api/v1/customer/${id}/matching_history`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });

            if (result) {
                this.customer = result.customer;
                this.histories = result.histories;
                this.counselors = result.counselors.map(d => ({ text: d.name, value: d.id }));
                this.counselors.unshift({text: "全て", value: 0});
                this.shops = result.shops.map(d => ({ text: d.name, value: d.id }));
                this.shops.unshift({text: "全て", value: 0});
                
                this.setTitle();
            }
            this.loading = false;
        },
        openSheet(sheet_id) {
            if(!sheet_id) return;
            window.open(`https://docs.google.com/spreadsheets/d/${sheet_id}`, '_blank')
        },
        getFilter() {
            return this.conditionsName + (this.conditionsShopId > 0 ? 's' : '') + (this.conditionsCounselorId > 0 ? 'c' : '') + (this.conditionsAge > 0 ? 'a' : '');
        },
        customFilter(items, search, filter) {
            if(this.conditionsName.length > 0 && filter.name.indexOf(this.conditionsName) === -1 ) return false;
            if(this.conditionsShopId !== 0 && filter.shop_id != this.conditionsShopId) return false;
            if(this.conditionsCounselorId !== 0 && filter.counselor_id != this.conditionsCounselorId) return false;
            if(this.conditionsAge !== 0) {
                switch(this.conditionsAge) {
                    case 20:    return (filter.age < 30);
                    case 30:    return (30 <= filter.age && filter.age < 40);
                    case 40:    return (40 <= filter.age && filter.age < 50);
                    case 50:    return (50 <= filter.age && filter.age < 60);
                    case 60:    return (60 <= filter.age);
                }
            }
            return true;
        },
        showCounselorName(counselorId) {
            const counselor = this.counselors.find(counselor => counselor.value == counselorId);
            if(!counselor) return '';
            return counselor.text;
        },
        showShopName(shopId) {
            const shop = this.shops.find(shop => shop.value == shopId);
            if(!shop) return '';
            return shop.text;
        },
        showKind(kind) {
            if(kind == 1) return "お相手選び";
            else return "お見合い";
        },
    }
}
</script>
